export default __webpack_public_path__ + "static/media/translations.467ac5cf.csv";